import { ServerCommunicationUtil } from 'utils/server_communication_util';
import { external } from './schema';

type CouponResponse = external['coupon_response.yaml']['components']['schemas']['CouponResponse'];

// eslint-disable-next-line import/prefer-default-export
export async function verify(couponCode: string): Promise<CouponResponse> {
  return fetch('/api/alltrails/coupons/verify', {
    body: JSON.stringify({ coupon_code: couponCode }),
    headers: {
      ...ServerCommunicationUtil.defaultAuthHeaders(),
      'Content-Type': 'application/json',
      'X-Language-Locale': __AT_DATA__.languageRegionCode
    },
    method: 'post'
  }).then(response => {
    // from https://www.tjvantoll.com/2015/09/13/fetch-and-errors/
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  });
}
